import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import * as Styles from "../../styles.ts";
import "../dui/icon/dui-icon.ts";
import "../dui/avatar/dui-avatar.ts";

const styles = css`
  :host {
    display: block;
    width: 100%;
    container-type: inline-size;
  }

  .acctmenu {
    display: grid;
    grid-template-columns: 1fr min-content;
    gap: var(--space-3);
    padding: var(--space-3);
    align-items: center;
    cursor: pointer;
    font-size: var(--font-size-sm);
    line-height: var(--line-height-snug);
    transition: background-color var(--duration-fast) ease-in-out;
    width: 100cqw;
    --icon-fg: var(--muted-foreground);
  }

  .acctmenu:hover {
    background-color: color-mix(in oklch, transparent 95%, var(--foreground));
  }

  .acctmenu-hgroup {
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
    margin-left: var(--space-3);
  }

  .acctmenu-username {
    font-weight: var(--font-weight-medium);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
  }

  .acctmenu-type {
    color: var(--muted-foreground);
  }

  .acctmenu-icon {
    margin-top: var(--space-0_5);
    align-self: start;
  }
`;

@customElement("acct-menu")
export class Acctmenu extends LitElement {
  static override styles = [Styles.base, styles];

  @property({ type: String })
  accessor username = "";

  @property({ type: String })
  accessor type = "";

  @property({ type: String })
  accessor pfp = "";

  override render() {
    return html`
      <aside class="acctmenu">
        <!--<dui-avatar
          size="var(--space-10)"
          src="${this.pfp}"
          style="--avatar-bg: var(--secondary)"
          >JC</dui-avatar
        >-->
        <div class="acctmenu-hgroup">
          <div class="acctmenu-username">${this.username}</div>
          <div class="acctmenu-type">${this.type}</div>
        </div>
        <dui-icon class="acctmenu-icon" icon="keyboard_arrow_up"></dui-icon>
      </aside>
    `;
  }
}
